import { transparentize } from 'polished'
import styled from 'styled-components'
import { BLUE_WHITER, GREEN, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const Container = styled.footer`
  background: ${GREEN};
`

export const Inside = styled.div`
  font-size: 14px;
  line-height: 19px;
  max-width: 1416px;
  color: ${transparentize(0.3, WHITE)};
  width: 100%;
  margin: 0 auto;
  padding: 63px 48px;

  hr {
    height: 2px;
    border: none;
    background: ${BLUE_WHITER};
    opacity: 0.2;
    margin: 34px 0px;

    @media (max-width: ${MD}) {
      opacity: 0;
    }
  }


  .flags, .social, .accept {
    display: flex;
    align-items: center;
    a {
      display: block;
      margin-right: 18px;
    }

    @media (max-width: ${MD}) {
      text-align: center;
      display: block;

      span {
        display: block;
      }

      img {
        height: 22px;
      }

      a {
        margin-top: 14px;
        display: inline-block;
      }
    }
  }

  .flags {
    @media (max-width: ${MD}) {
      margin-top: 108px;
    }
  }

  .accept {
    @media (max-width: ${MD}) {
      margin-top: 50px;
      img {
        display: inline-block !important;
        width: auto;
        height: 36px;
        margin-top: 6px;
      }
    }
  }

  .social {
    span {
      margin-right: 10px;
    }
  }

  .social, .accept {
    a:first-child {
      margin-left: 18px;
    }
    a:last-child {
      margin-right: 0px;
    }
  }

  .contact {
    margin-left: 24px;

    @media (max-width: ${MD}) {
      margin-left: 0;
    }
  }

  .info {
    max-width: 219px;

    @media (max-width: ${MD}) {
      margin: 0 auto;
      text-align: center;
      margin-bottom: 65px;

      .logo {
        margin: 0 auto;
        margin-bottom: 38px;
      }
    }
  }

  .logo {
    width: 107px;
    display: block;
    margin-bottom: 28px;
    line-height: 18px;
  }

  nav {
    display: flex;
    ul {
      flex: 1;

      li {
        margin-bottom: 27px;
      }

      a {
        color: ${WHITE};
        text-decoration: none;
      }
    }
  }

  .top, .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${MD}) {
      display: block;
    }
  }

  .bottom {
    @media (max-width: ${MD}) {
      text-align: center;
    }
  }

  .footer {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    align-items: center;

    @media (max-width: ${MD}) {
      display: block;
    }
  }
`
